module.exports = __webpack_public_path__ + "img/target.9ba4b7c7.png";